import { createSelector } from 'reselect';

export const getMonitorState = (state) => state.monitor || [];

export const getData15Min = createSelector(
    getMonitorState,
    (monitor) => monitor.data15Min,
);
export const getData15MinError = createSelector(
    getMonitorState,
    (monitor) => monitor.data15MinError,
);
export const getFetching15Min = createSelector(
    getMonitorState,
    (monitor) => monitor.fetching15Min,
);
export const getData15MinInterval = createSelector(
    getMonitorState,
    (monitor) => monitor.data15MinInterval,
);
export const getStartDate15Min = createSelector(
    getMonitorState,
    (monitor) => monitor.startDate15Min,
);

export const getEndDate15Min = createSelector(
    getMonitorState,
    (monitor) => monitor.endDate15Min,
);

export const getData1Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.data1Hour,
);
export const getData1HourError = createSelector(
    getMonitorState,
    (monitor) => monitor.data1HourError,
);
export const getFetching1Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.fetching1Hour,
);
export const getData1HourInterval = createSelector(
    getMonitorState,
    (monitor) => monitor.data1HourInterval,
);

export const getStartDate1Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.startDate1Hour,
);

export const getEndDate1Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.endDate1Hour,
);

export const getData6Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.data6Hour,
);
export const getData6HourError = createSelector(
    getMonitorState,
    (monitor) => monitor.data6HourError,
);
export const getFetching6Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.fetching6Hour,
);
export const getData6HourInterval = createSelector(
    getMonitorState,
    (monitor) => monitor.data6HourInterval,
);
export const getStartDate6Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.startDate6Hour,
);

export const getEndDate6Hour = createSelector(
    getMonitorState,
    (monitor) => monitor.endDate6Hour,
);
